import React from "react";
import "../../Style/Projects.scss";
import Banner from "../../Assets/Images/Projects/projects-banner.webp";
import { Accordion } from "react-bootstrap";
import { useAccordionButton } from "react-bootstrap/AccordionButton";
import Card from "react-bootstrap/Card";
import $ from "jquery";
import HorizontalScroll from "react-scroll-horizontal";
import { useLocation } from "react-router-dom";
import k1 from "../../Assets/Images/Projects/K-1.png";
import k2 from "../../Assets/Images/Projects/K-2.png";
import k3 from "../../Assets/Images/Projects/K-3.png";
import k4 from "../../Assets/Images/Projects/K-4.png";
import b1 from "../../Assets/Images/Projects/B-1.png";
import b2 from "../../Assets/Images/Projects/B-2.png";
import b3 from "../../Assets/Images/Projects/B-3.png";
import b4 from "../../Assets/Images/Projects/B-4.png";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { useEffect, useState } from "react";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
function CustomToggle({ children, eventKey }) {
  const decoratedOnClick = useAccordionButton(eventKey, () => {
    if (eventKey === "0") {
      $("#1").toggleClass("white");
      $("#2").removeClass("white");
      $("#3").removeClass("white");
      $("#4").removeClass("white");
      $("html, body").animate(
        {
          scrollTop: $("#Indonesia").offset().top - 140,
        },
        100
      );
    }
    if (eventKey === "1") {
      $("#1").removeClass("white");
      $("#2").toggleClass("white");
      $("#3").removeClass("white");
      $("#4").removeClass("white");
      $("html, body").animate(
        {
          scrollTop: $("#Philippines").offset().top - 140,
        },
        100
      );
    }

    if (eventKey === "2") {
      $("#1").removeClass("white");
      $("#2").removeClass("white");
      $("#3").toggleClass("white");
      $("#4").removeClass("white");
      $("html, body").animate(
        {
          scrollTop: $("#Malaysia").offset().top - 140,
        },
        100
      );
    }

    if (eventKey === "3") {
      $("#1").removeClass("white");
      $("#2").removeClass("white");
      $("#3").removeClass("white");
      $("#4").toggleClass("white");
      $("html, body").animate(
        {
          scrollTop: $("#Australia").offset().top - 140,
        },
        100
      );
    }
  });

  return (
    <button
      type="button"
      style={{ color: "#FDBF4A", backgroundColor: "transparent" }}
      onClick={decoratedOnClick}
    >
      {children}
    </button>
  );
}

function Project() {
  const [isMobile, setIsMobile] = useState(false);
  gsap.registerPlugin(ScrollTrigger);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const ScrollToHashElement = () => {
    const location = useLocation();

    useEffect(() => {
      const hash = location.hash;
      if (hash) {
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
        setTimeout(() => {
          const el = document.querySelector(hash);
          if (el) {
            const yOffset = -100;
            const y =
              el.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: "smooth" });
          }
        }, 100);
      }
    }, [location]);

    return null;
  };

  useEffect(() => {
    gsap.from(".Line", {
      width: 0,
    });
    gsap.to(".Line", {
      scrollTrigger: {
        trigger: ".Line",
      },
      width: "100%",
      duration: 2,
    });
  });
  return (
    <div className="Projects-Container">
      <div className="Section-1">
        <div className="Title-Container">
          <h1>Risjadson Land Experience</h1>
          <div className="Line-Box">
            <span className="Line" />
          </div>
        </div>
        <img src={Banner} />
      </div>
      <div className="Section-2">
        <div className="Accordion-Section">
          <Accordion>
            <section id="Indonesia">
              <Card>
                <Card.Header id="1">
                  <h2>INDONESIA</h2>
                  <CustomToggle eventKey="0">
                    <span>+</span>
                  </CustomToggle>
                </Card.Header>
                <Accordion.Collapse eventKey="0">
                  <Card.Body>
                    {isMobile ? (
                      <div className="scroll-wrapper">
                        <img
                        style={{ marginRight: "20px", width: "100%" }}
                        src={
                          "https://res.cloudinary.com/doy2qixs5/image/upload/v1745492532/rbn/projects/indonesia/ikn-1_nm45sw.jpg"
                        }
                      />
                      <img
                        style={{ marginRight: "20px", width: "100%" }}
                        src={
                          "https://res.cloudinary.com/doy2qixs5/image/upload/v1745492533/rbn/projects/indonesia/ikn-2_s6k6zc.jpg"
                        }
                      />
                      <img
                        style={{ marginRight: "20px", width: "100%" }}
                        src={
                          "https://res.cloudinary.com/doy2qixs5/image/upload/v1745492532/rbn/projects/indonesia/menara-batavia_yrpq7s.jpg"
                        }
                      />
                      <img
                        style={{ marginRight: "20px", width: "100%" }}
                        src={
                          "https://res.cloudinary.com/doy2qixs5/image/upload/v1745492532/rbn/projects/indonesia/rs-pondok-indah_bfgodp.jpg"
                        }
                      />
                      <img
                        style={{ marginRight: "20px", width: "100%" }}
                        src={
                          "https://res.cloudinary.com/doy2qixs5/image/upload/v1746704360/rbn/projects/indonesia/rumah-radio-dalam_j09rit.jpg"
                        }
                      />
                      <img
                        style={{ marginRight: "20px", width: "100%" }}
                        src={
                          "https://res.cloudinary.com/doy2qixs5/image/upload/v1746704360/rbn/projects/indonesia/pos-pengumben-indonesia-exp_ajx1l8.jpg"
                        }
                      />
                      <img
                        style={{ marginRight: "20px", width: "100%" }}
                        src={
                          "https://res.cloudinary.com/doy2qixs5/image/upload/v1746704359/rbn/projects/indonesia/MTH_tkd7gg.jpg"
                        }
                      />
                      </div>
                    ) : (
                      <HorizontalScroll
                      style={{ height: "60vh", width: "100%" }}
                      reverseScroll="true"
                    >
                      <img
                        style={{ marginRight: "20px", width: "100%" }}
                        src={
                          "https://res.cloudinary.com/doy2qixs5/image/upload/v1745492532/rbn/projects/indonesia/ikn-1_nm45sw.jpg"
                        }
                      />
                      <img
                        style={{ marginRight: "20px", width: "100%" }}
                        src={
                          "https://res.cloudinary.com/doy2qixs5/image/upload/v1745492533/rbn/projects/indonesia/ikn-2_s6k6zc.jpg"
                        }
                      />
                      <img
                        style={{ marginRight: "20px", width: "100%" }}
                        src={
                          "https://res.cloudinary.com/doy2qixs5/image/upload/v1745492532/rbn/projects/indonesia/menara-batavia_yrpq7s.jpg"
                        }
                      />
                      <img
                        style={{ marginRight: "20px", width: "100%" }}
                        src={
                          "https://res.cloudinary.com/doy2qixs5/image/upload/v1745492532/rbn/projects/indonesia/rs-pondok-indah_bfgodp.jpg"
                        }
                      />
                      <img
                        style={{ marginRight: "20px", width: "100%" }}
                        src={
                          "https://res.cloudinary.com/doy2qixs5/image/upload/v1746704360/rbn/projects/indonesia/rumah-radio-dalam_j09rit.jpg"
                        }
                      />
                      <img
                        style={{ marginRight: "20px", width: "100%" }}
                        src={
                          "https://res.cloudinary.com/doy2qixs5/image/upload/v1746704360/rbn/projects/indonesia/pos-pengumben-indonesia-exp_ajx1l8.jpg"
                        }
                      />
                      <img
                        style={{ marginRight: "20px", width: "100%" }}
                        src={
                          "https://res.cloudinary.com/doy2qixs5/image/upload/v1746704359/rbn/projects/indonesia/MTH_tkd7gg.jpg"
                        }
                      />
                    </HorizontalScroll>
                    )}
                    <h3></h3>
                    <div style={{ width: "100%", padding: "20px 0px" }}>
                      <p className="Desc">RS Pondok Indah</p>
                      <p className="Desc">Menara Batavia</p>
                      <p className="Desc">Graha Hijau Townhouse</p>
                      <p className="Desc">Sriwijaya Hotel</p>
                      <p className="Desc">Fountain Park Apartment</p>
                      <p className="Desc">Gedung Panin Center</p>
                      <p className="Desc">⁠Menteng Garden Town House</p>
                      <p className="Desc">⁠Otista Shophouse</p>
                      <p className="Desc">⁠Margonda Shophouse</p>
                      <p className="Desc">⁠Tebet Shophouse</p>
                      <p className="Desc">⁠Cibubur Shophouse</p>
                      <p className="Desc">⁠Kebon Jeruk Shophouse</p>
                      <p className="Desc">⁠Pintu Air Housing</p>
                      <p className="Desc">Batavia Apartment⁠</p>
                    </div>

                    {/* <div className='Detail-Section'>
                                        <div className='Top-Section'>
                                            <div className='Column' >
                                                <span className='sub-title'>Sector</span>
                                                <p>
                                                    Hospitality &
                                                    <span>Residental</span>
                                                </p>
                                            </div>
                                            <div className='Column' >
                                                <span className='sub-title'>Status</span>
                                                <p>Ongoing</p>
                                            </div>
                                        </div>
                                        <div className='Bottom-Section'>
                                            <div className='Column' >
                                                <span className='sub-title'>Location</span>
                                                <p>
                                                    Kalimantan,
                                                    <span>Indonesia</span>
                                                </p>
                                            </div>
                                            <div className='Column' >
                                                <span className='sub-title'>Scope</span>
                                                <p>
                                                    Architecture,
                                                    <span>Masterplanning</span>
                                                </p></div>
                                        </div>
                                    </div> */}
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </section>
            <section id="Philippines">
              <Card>
                <Card.Header id="2">
                  <h2>PHILIPPINES</h2>
                  <CustomToggle eventKey="1">
                    <span>+</span>
                  </CustomToggle>
                </Card.Header>
                <Accordion.Collapse eventKey="1">
                  <Card.Body>
                    <HorizontalScroll
                      style={{ height: "60vh", width: "100%" }}
                      reverseScroll="true"
                    >
                      <img
                        style={{ marginRight: "20px", width: "100%" }}
                        src={
                          "https://res.cloudinary.com/doy2qixs5/image/upload/v1745496619/rbn/projects/philippines/philippines-1_hefw8d.png"
                        }
                      />
                      <img
                        style={{ marginRight: "20px", width: "100%" }}
                        src={
                          "https://res.cloudinary.com/doy2qixs5/image/upload/v1745496620/rbn/projects/philippines/philippines-2_yoe3ch.png"
                        }
                      />
                      <img
                        style={{ marginRight: "20px", width: "100%" }}
                        src={
                          "https://res.cloudinary.com/doy2qixs5/image/upload/v1746706380/rbn/projects/philippines/philippines-3_cw9hqo.jpg"
                        }
                      />
                      <img
                        style={{ marginRight: "20px", width: "100%" }}
                        src={
                          "https://res.cloudinary.com/doy2qixs5/image/upload/v1746706380/rbn/projects/philippines/philippines-4_jdqnvd.jpg"
                        }
                      />
                      <img
                        style={{ marginRight: "20px", width: "100%" }}
                        src={
                          "https://res.cloudinary.com/doy2qixs5/image/upload/v1746706381/rbn/projects/philippines/philippines-5_fn4emu.jpg"
                        }
                      />
                      <img
                        style={{ marginRight: "20px", width: "100%" }}
                        src={
                          "https://res.cloudinary.com/doy2qixs5/image/upload/v1746706381/rbn/projects/philippines/philippines-6_pxfr1r.png"
                        }
                      />
                    </HorizontalScroll>
                    <h3></h3>
                    <div style={{ width: "100%", padding: "20px 0px" }}>
                      <p className="Desc"> Fidel Del Ray, Indang, Cavite</p>
                      <p className="Desc">Lasang Del Ray Homes, Davao</p>
                    </div>

                    {/* <div className='Detail-Section'>
                                        <div className='Top-Section'>
                                            <div className='Column' >
                                                <span className='sub-title'>Sector</span>
                                                <p>
                                                    Hospitality &
                                                    <span>Residental</span>
                                                </p>
                                            </div>
                                            <div className='Column' >
                                                <span className='sub-title'>Status</span>
                                                <p>Ongoing</p>
                                            </div>
                                        </div>
                                        <div className='Bottom-Section'>
                                            <div className='Column' >
                                                <span className='sub-title'>Location</span>
                                                <p>
                                                    Kalimantan,
                                                    <span>Indonesia</span>
                                                </p>
                                            </div>
                                            <div className='Column' >
                                                <span className='sub-title'>Scope</span>
                                                <p>
                                                    Architecture,
                                                    <span>Masterplanning</span>
                                                </p></div>
                                        </div>
                                    </div> */}
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </section>
            <section id="Malaysia">
              <Card>
                <Card.Header id="3">
                  <h2>MALAYSIA</h2>
                  <CustomToggle eventKey="2">
                    <span>+</span>
                  </CustomToggle>
                </Card.Header>
                <Accordion.Collapse eventKey="2">
                  <Card.Body>
                    <HorizontalScroll
                      style={{ height: "60vh", width: "100%" }}
                      reverseScroll="true"
                    >
                      <img
                        style={{ marginRight: "20px", width: "100%" }}
                        src={
                          "https://res.cloudinary.com/doy2qixs5/image/upload/v1745494050/rbn/projects/malaysia/ICAM-student-hostel_ibacu2.jpg"
                        }
                      />
                      <img
                        style={{ marginRight: "20px", width: "100%" }}
                        src={
                          "https://res.cloudinary.com/doy2qixs5/image/upload/v1745494049/rbn/projects/malaysia/petronas-p14-1_fv35fu.jpg"
                        }
                      />
                      <img
                        style={{ marginRight: "20px", width: "100%" }}
                        src={
                          "https://res.cloudinary.com/doy2qixs5/image/upload/v1745494049/rbn/projects/malaysia/Petronas-P14_algdwm.png"
                        }
                      />
                      <img
                        style={{ marginRight: "20px", width: "100%" }}
                        src={
                          "https://res.cloudinary.com/doy2qixs5/image/upload/v1745494049/rbn/projects/malaysia/petronas-p14-2_tles02.jpg"
                        }
                      />
                      <img
                        style={{ marginRight: "20px", width: "100%" }}
                        src={
                          "https://res.cloudinary.com/doy2qixs5/image/upload/v1745494049/rbn/projects/malaysia/petronas-p14-3_hnynij.jpg"
                        }
                      />
                      <img
                        style={{ marginRight: "20px", width: "100%" }}
                        src={
                          "https://res.cloudinary.com/doy2qixs5/image/upload/v1745494048/rbn/projects/malaysia/desaru-staff-quarters_yrpstc.jpg"
                        }
                      />
                    </HorizontalScroll>
                    <h3></h3>
                    <div style={{ width: "100%", padding: "20px 0px" }}>
                      <p className="Desc">
                        Petronas P14, Pengerang Workers Village
                      </p>
                      <p className="Desc">Desaru Staff Quarters</p>
                      <p className="Desc">ICAM Student Hostel</p>
                      <p className="Desc">G Residence</p>
                      <p className="Desc">Sunway Iskandar</p>
                    </div>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </section>
            <section id="Australia">
              <Card>
                <Card.Header id="4">
                  <h2>AUSTRALIA</h2>
                  <CustomToggle eventKey="3">
                    <span>+</span>
                  </CustomToggle>
                </Card.Header>
                <Accordion.Collapse eventKey="3">
                  <Card.Body>
                    <HorizontalScroll
                      style={{ height: "60vh", width: "100%" }}
                      reverseScroll="true"
                    >
                      <img
                        style={{ marginRight: "20px", width: "100%" }}
                        src={
                          "https://res.cloudinary.com/doy2qixs5/image/upload/v1745492635/rbn/projects/australia/cockburn-1_nereat.jpg"
                        }
                      />
                      <img
                        style={{ marginRight: "20px", width: "100%" }}
                        src={
                          "https://res.cloudinary.com/doy2qixs5/image/upload/v1745492638/rbn/projects/australia/cockburn-2_wvty0r.jpg"
                        }
                      />
                      <img
                        style={{ marginRight: "20px", width: "100%" }}
                        src={
                          "https://res.cloudinary.com/doy2qixs5/image/upload/v1745492637/rbn/projects/australia/cockburn-3_pempca.jpg"
                        }
                      />
                      <img
                        style={{ marginRight: "20px", width: "100%" }}
                        src={
                          "https://res.cloudinary.com/doy2qixs5/image/upload/v1745492634/rbn/projects/australia/cockburn-4_qwt8jb.jpg"
                        }
                      />
                      <img
                        style={{ marginRight: "20px", width: "100%" }}
                        src={
                          "https://res.cloudinary.com/doy2qixs5/image/upload/v1745492636/rbn/projects/australia/cockburn-6_x1dv8j.jpg"
                        }
                      />
                      <img
                        style={{ marginRight: "20px", width: "100%" }}
                        src={
                          "https://res.cloudinary.com/doy2qixs5/image/upload/v1745492635/rbn/projects/australia/darwin-soho_tp7wf2.jpg"
                        }
                      />
                      <img
                        style={{ marginRight: "20px", width: "100%" }}
                        src={
                          "https://res.cloudinary.com/doy2qixs5/image/upload/v1745492634/rbn/projects/australia/hougoumont-hotel-1_rqshkj.jpg"
                        }
                      />
                      <img
                        style={{ marginRight: "20px", width: "100%" }}
                        src={
                          "https://res.cloudinary.com/doy2qixs5/image/upload/v1745492634/rbn/projects/australia/hougoumont-hotel-2_t5qwyu.jpg"
                        }
                      />
                      <img
                        style={{ marginRight: "20px", width: "100%" }}
                        src={
                          "https://res.cloudinary.com/doy2qixs5/image/upload/v1745492636/rbn/projects/australia/hougoumont-hotel-4_aceso6.jpg"
                        }
                      />
                      <img
                        style={{ marginRight: "20px", width: "100%" }}
                        src={
                          "https://res.cloudinary.com/doy2qixs5/image/upload/v1745492636/rbn/projects/australia/hougoumont-hotel-5_ogtvyr.jpg"
                        }
                      />
                      <img
                        style={{ marginRight: "20px", width: "100%" }}
                        src={
                          "https://res.cloudinary.com/doy2qixs5/image/upload/v1745492635/rbn/projects/australia/onslow_rjigsy.jpg"
                        }
                      />
                    </HorizontalScroll>
                    <h3></h3>
                    <div style={{ width: "100%", padding: "20px 0px" }}>
                      <p className="Desc">Darwin Soho Tower</p>
                      <p className="Desc">Cockburn Apartment</p>
                    </div>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </section>
          </Accordion>
        </div>
      </div>
    </div>
  );
}

export default Project;
